module.exports = __webpack_public_path__ + "img/alipay.4e7e5b75.png";